import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import { func } from "prop-types";
import { userGuid } from "../../utils/general-config";

const GetUserById = (userGuid) => {
  return function () {
    return AssessmentServiceApi.getUserById(userGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const updateUser = (data) => {
  return function () {
    return AssessmentServiceApi.updateUser(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const changePassword = (data) => {
  return function () {
    return AssessmentServiceApi.changePassword(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Change Password Error", error));
  };
};
const accountCancellation = (data) => {
  return function () {
    return AssessmentServiceApi.accountCancellation(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Account Cancellation Error", error));
  };
};
const getTransactionDetail = (userGuid) => {
  return function () {
    return AssessmentServiceApi.getTransactionDetail(userGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Transaction  Error", error));
  };
};
const getBilling = (data) => {
  return function () {
    return AssessmentServiceApi.getBilling(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Billing Error", error));
  };
};

const getGuestUser = (parentGuid) => {
  return function () {
    return AssessmentServiceApi.getGuestUser(parentGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest Error", error));
  };
};

const createGuestUser = (data) => {
  return function () {
    return AssessmentServiceApi.createGuestUser(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};

const updateGuestUser = (data) => {
  return function () {
    return AssessmentServiceApi.updateGuestUser(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};

const isGuestOrPremiumUser = (userGuid) => {
  return function () {
    return AssessmentServiceApi.isGuestOrPremiumUser(userGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Premium and Guest User Error", error));
  };
};

const accountReActivate = (data) => {
  return function () {
    return AssessmentServiceApi.accountReActivate(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Account Reactivate Error", error));
  };
};

export {
  GetUserById,
  changePassword,
  accountCancellation,
  getTransactionDetail,
  getBilling,
  updateUser,
  getGuestUser,
  createGuestUser,
  updateGuestUser,
  isGuestOrPremiumUser,
  accountReActivate,
};
